import React from "react";

export default function UserVoteLoadingState() {
  return (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
      {Array.from({ length: 6 }).map((_, index) => (
        <div
          key={index}
          className="h-[260px] animate-pulse rounded-[26px] border border-slate-200 bg-slate-50 dark:border-slate-800 dark:bg-slate-800/60"
        />
      ))}
    </div>
  );
}